import React, { useState } from 'react';
import './DieselCenterItems.css';

const DieselCenterItems = ({ items }) => {
  const [hoveredItem, setHoveredItem] = useState(null);

  return (
    <div className="dci-services-container">
      <h1 className="dci-services-title">{items.title}</h1>

      <div className="dci-services-list">
        {/* Service Item A */}
        {items.items.map((item, index) => (
          <div 
            className="dci-service-item" 
            key={index}
            onMouseEnter={() => setHoveredItem(index)}
            onMouseLeave={() => setHoveredItem(null)}
          >
            <div className="dci-image-container">
              <img
                src={item.image}
                alt={item.title}
                className="dci-service-image"
              />
              <div className="dci-image-overlay">
                <span>{item.title}</span>
              </div>
            </div>
            <div className="dci-content-container">
              <div className="dci-content-header">
                <h2 className="dci-item-title">{item.title}</h2>
                <div className="dci-divider"></div>
              </div>
              <p className="dci-item-description">
                {item.description}
              </p>

              {item.subcategories && (
                <div className="dci-subcategories-wrapper">
                  <h3 className="dci-subcategories-title">What we offer:</h3>
                  <ul className="subcategories-list">
                    {item.subcategories.map(subcategory => (
                      <li key={subcategory.id} className="subcategory-item">
                        <div className="subcategory-bullet"></div>
                        <span className="subcategory-text">
                          <b>{subcategory.title ?? 'NA'}</b>: {subcategory.name}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {/* {!item.subcategories && (
                <div className="dci-learn-more">
                  <span>Learn more</span>
                  <i className="fas fa-arrow-right"></i>
                </div>
              )} */}
            </div>
          </div>
        ))}


        {/* Service Item B */}
        {/* <div className="dci-service-item">
          <div className="dci-image-container">
            <img 
              src="/api/placeholder/300/200"
              alt="Service B"
              className="dci-service-image"
            />
          </div>
          <div className="dci-content-container">
            <h2 className="dci-item-title">Item B</h2>
            <p className="dci-item-description">
              Detailed description for Item B. This can include multiple lines of text
              explaining the service or product features.
            </p>
          </div>
        </div> */}

        {/* Service Item C */}
        {/* <div className="dci-service-item">
          <div className="dci-image-container">
            <img 
              src="/api/placeholder/300/200"
              alt="Service C"
              className="dci-service-image"
            />
          </div>
          <div className="dci-content-container">
            <h2 className="dci-item-title">Item C</h2>
            <p className="dci-item-description">
              Detailed description for Item C. This can include multiple lines of text
              explaining the service or product features.
            </p>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default DieselCenterItems;